const DELAYS = ["0s", "0.14s", "0.28s", "0.42s", "0.56s"];
const DURATIONS = ["0.9s", "1.15s", "0.8s", "1.25s", "1s"];

export default function Equalizer() {
  return (
    <div
      data-testid="equalizer"
      className="flex items-end justify-center gap-1 h-5"
      aria-hidden
    >
      {DELAYS.map((delay, i) => (
        <span
          key={i}
          className="eq-bar w-[3px] h-full rounded-full bg-sky-500"
          style={{ animationDelay: delay, animationDuration: DURATIONS[i] }}
        />
      ))}
    </div>
  );
}
